<script setup lang="ts">
import './assets/style.scss'
import { usePagePreloader } from './../model/model'

const store = usePagePreloader()
</script>

<template>
  <div class="v-page-preloader" v-if="store.visible">
    <VProgressLinear color="primary" indeterminate />
  </div>
</template>
